import React from 'react'

import {Badge, Colors} from '../UI/index.js'
import {routeStatusLabels, RouteStatus} from './routeSummary.js'

const badgeProps: Record<RouteStatus, React.ComponentProps<typeof Badge>> = {
    concept: {variant: 'grey'},
    ready: {color: Colors.infoPale},
    started: {variant: 'info', textColor: Colors.textDark},
    completed: {variant: 'success'}
}

/** Concept, Gereed, Onderweg or Afgerond (getRouteStatus), as on the route cards of the planning */
export default function RouteStatusBadge({status}: {status: RouteStatus}) {
    return <Badge {...badgeProps[status]}>{routeStatusLabels[status]}</Badge>
}
